export function parseDateValue(value) {
  if (!value) return null;

  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }

  if (typeof value === "number") {
    let ms = value;
    if (ms > 1e9 && ms < 1e12) ms *= 1000;

    const d = new Date(ms);
    return Number.isNaN(d.getTime()) ? null : d;
  }

  const raw = String(value).trim();
  if (!raw) return null;

  const numeric = Number(raw);
  if (Number.isFinite(numeric)) {
    let ms = numeric;
    if (ms > 1e9 && ms < 1e12) ms *= 1000;

    const d = new Date(ms);
    if (!Number.isNaN(d.getTime())) return d;
  }

  if (
    raw.endsWith("Z") ||
    /[+-]\d{2}:\d{2}$/.test(raw) ||
    /[+-]\d{4}$/.test(raw)
  ) {
    const d = new Date(raw);
    return Number.isNaN(d.getTime()) ? null : d;
  }

  const m = raw.match(
    /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})(?::(\d{2}))?(?:\.(\d{1,3}))?$/
  );

  if (m) {
    const [, y, mo, d, h, mi, s = "0", ms = "0"] = m;

    const parsed = new Date(
      Number(y),
      Number(mo) - 1,
      Number(d),
      Number(h),
      Number(mi),
      Number(s),
      Number(ms.padEnd(3, "0"))
    );

    return Number.isNaN(parsed.getTime()) ? null : parsed;
  }

  const fallback = new Date(raw);
  return Number.isNaN(fallback.getTime()) ? null : fallback;
}

export function formatKST(value) {
  const date = parseDateValue(value);
  if (!date) return "-";

  return date.toLocaleString("ko-KR", {
    timeZone: "Asia/Seoul",
    hour12: true,
  });
}

export function toMillis(value) {
  const d = parseDateValue(value);
  return d ? d.getTime() : 0;
}

export function isFresh(value, maxAgeSec = 15) {
  const ms = toMillis(value);
  if (!ms) return false;

  return (Date.now() - ms) / 1000 <= maxAgeSec;
}